import { DeliveryItems } from '@/api';
import { useAppDispatch } from '@/app/store';
import { DeliveryListItem } from '@/components/layout/DeliveryListItem';
import { UIList } from '@/components/ui/List';
import {
  deselectDelivery,
  selectDelivery,
} from '@/features/deliveries/deliveriesSlice';
import { useSelector } from '@/hooks/useSelector';
import { useDeliverySelectionRules } from '@/hooks/useDeliverySelectionRules';

type DeliveryListProps = {
  deliveries: DeliveryItems[];
  onBoxesClick?: (deliveryCode: string, boxes: string[]) => void;
};

const DeliveryList = ({
  deliveries,
  onBoxesClick,
}: DeliveryListProps): JSX.Element => {
  const dispatch = useAppDispatch();

  const { selectedDeliveries } = useSelector(state => state.deliveries);

  const { isChecked, isDisabled, selectedCodes } =
    useDeliverySelectionRules(selectedDeliveries);

  const handleToggle = (delivery: DeliveryItems): void => {
    const isSelected = selectedCodes.has(delivery.codeDelivery);

    if (isSelected) {
      dispatch(deselectDelivery(delivery));
    } else {
      dispatch(selectDelivery(delivery));
    }
  };

  return (
    <UIList margin={[0, 0, 100]} padding={[16, 0]}>
      {deliveries.map(delivery => (
        <DeliveryListItem
          key={delivery.codeDelivery}
          delivery={delivery}
          checked={isChecked(delivery.codeDelivery)}
          disabled={isDisabled(delivery)}
          onToggle={handleToggle}
          onBoxesClick={onBoxesClick}
        />
      ))}
    </UIList>
  );
};

export default DeliveryList;
